<style scoped>
    .table-header{
        padding: 6px;
        text-align: center;
        font-weight: bold;
    }
</style>
<template>
    <div>
        <Table :size="size" :columns="columns" :data="records" :loading="loading">
            <div slot="header" class="table-header" v-if="showTitle">到货情况</div>
            <div class="table-header" slot="footer">
                <Page
                    size="small"
                    show-total
                    :current="page_info.current"
                    :total="page_info.total"
                    :page-size="page_info.page_size"
                    @on-change="pageChange">
                </Page>
            </div>
        </Table>
    </div>
</template>
<script>
    import ViewerItem from '../../components/viewer/item';
    import StockUtil from '../libs/util';
    export default {
        components: { ViewerItem },
        /*
        * 3种查询
        * 1. 只提供合同id，查询合同下所有物料的到货情况
        * 2. 只提供存货id，查询存货的历史到货情况
        * 3. 同时提供，查询合同下该存货的到货情况
        * */
        props: {
            showTitle:{
                type: Boolean,
                default: true
            },
            contract_id: {
                type: Number,
            },
            stock_id: {
                type: Number,
            },
            size: {
                type: String,
                default: 'default'
            }
        },
        data(){
            return {
                params: {
                    page: 1,
                    per_page: 10
                },
                page_info: {
                    current: 1,
                    total: 0,
                    page_size: 10
                },
                loading: false,
                records: [],
                columns: [
                    {
                        title: '入库单号',
                        align: 'center',
                        width: 120,
                        key: 'bill_no'
                    },
                    {
                        title: '入库类型',
                        align: 'center',
                        width: 80,
                        render: (h, params)=>{
                            let row = params.row;
                            return h('span', {
                                class: {
                                    'color-error': row.in_type === 'return_stock'
                                }
                            }, StockUtil.getInTypeName(row.in_type));
                        }
                    },
                    {
                        title: '采购合同',
                        align: 'center',
                        width: 120,
                        render: (h, params)=>{
                            const row = params.row;
                            const contract_id = row.contract_id;
                            if(contract_id > 0){
                                return h(ViewerItem, {
                                    props: {
                                        type: 'Contract',
                                        model_id: contract_id
                                    },
                                    'class': {
                                        link: true
                                    }
                                }, row.contract_uid);
                            }else{
                                return h('div', [
                                    h('span', row.contract_uid),
                                    h('div', {
                                        'class': {'color-error': true}
                                    }, '未关联合同'),
                                ]);
                            }
                        }
                    },
                    {
                        title: '存货',
                        align: 'center',
                        width: 100,
                        render: (h, params)=>{
                            const row = params.row;
                            const stock = row.stock;
                            if (stock) {
                                return h(ViewerItem, {
                                    props: {
                                        type: 'Stock',
                                        model_id: stock.id
                                    },
                                    'class': {
                                        link: true
                                    }
                                }, [
                                    h('div', stock.uid),
                                    h('div', stock.name),
                                ]);
                            } else {
                                return h('div', row.stock_uid.split('-')[0]);
                            }
                        }
                    },
                    {
                        title: '入库数量',
                        align: 'right',
                        width: 70,
                        render: (h, params)=>{
                            const row = params.row;
                            return h('div', this.$util.formatNumber(row.qty));
                        }
                    },
                    {
                        title: '含税单价',
                        align: 'right',
                        width: 70,
                        render: (h, params)=>{
                            const row = params.row;
                            return h('div', this.$util.formatPrice(row.unit_price));
                        }
                    },
                    {
                        title: '总价',
                        align: 'right',
                        width: 80,
                        render: (h, params)=>{
                            const row = params.row;
                            return h('div', this.$util.formatPrice(row.total_price));
                        }
                    },
                    {
                        title: '入库日期',
                        align: 'center',
                        width: 80,
                        key: 'in_date'
                    },

                    {
                        title: '供应商',
                        align: 'center',
                        width: 120,
                        render: (h, params)=>{
                            const row = params.row;
                            return h('div', row.supplier_name || '-');
                        }
                    },
                    {
                        title: '仓库',
                        align: 'center',
                        width: 80,
                        render: (h, params)=>{
                            const row = params.row;
                            return h('div', row.warehouse_name || '-');
                        }
                    },

                    {
                        title: '单据备注',
                        align: 'center',
                        key: 'bill_note',
                        width: 120,
                    },
                    {
                        title: '明细备注',
                        align: 'center',
                        key: 'list_note',
                        width: 120,
                    }
                ]
            }
        },
        computed: {
            //
        },
        created(){
            this.getStockInRecords();
        },
        mounted(){
            //
        },
        methods: {
            getStockInRecords(){
                if (this.loading) return;
                this.loading = true;
                this.$util.ajax.get(this.$util.api.query_stock_arrived, {
                    params: Object.assign({
                        contract_id: this.contract_id,
                        stock_id: this.stock_id
                    }, this.params)
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        const data = res.data;
                        this.records = data.records;
                        this.page_info.current = data.cur_page;
                        this.page_info.page_size = data.per_page;
                        this.page_info.total = data.total_count;
                    }else{
                        this.$Modal.warning({title: '错误', content: res.msg});
                    }
                }).catch((e)=>{
                    this.$Modal.warning({title: '错误', content: e.message});
                }).finally(()=>{
                    this.loading = false;
                });
            },
            pageChange(new_page){
                this.params.page = new_page;
                this.getStockInRecords();
            },
        }
    }
</script>
